import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import { routes } from 'src/routes';
import { LoginPage } from './login.page';
import { VerificationPage } from './verification.page';
import { RegistrationPage } from './registration.page';
import { ForgotPassword } from './forgot-password';

export const AuthRouter = () => {
	return (
		<Switch>
			<Route path={routes.root.auth.login.path}>
				<LoginPage/>
			</Route>
			<Route path={routes.root.auth.registration.path}>
				<RegistrationPage/>
			</Route>
			<Route path={routes.root.auth.forgot.path}>
				<ForgotPassword/>
			</Route>
			<Route path={routes.root.auth.verification.path}>
				<VerificationPage/>
			</Route>
			<Redirect
				from={routes.root.auth.path}
				to={routes.root.auth.login.path}
			/>
		</Switch>
	);
};
